module.exports = __webpack_public_path__ + "media/choose_a_renter.2253d8dd.svg";